module.exports = __webpack_public_path__ + "img/switch.77fcecd9.png";